import { DashboardResponse } from 'commons/src/actions/DashboardActions';
import { RequestActionType } from 'commons/src/actions/requestActions';
import { PublicDashboardProps } from '../models/commons';
import { PublicRequestType } from '../reducers/requestReducer';
import { EmptyAction } from './index';

export enum PublicDashboardActionType {
    FetchPublicDashboard = 'FETCH_PUBLIC_DASHBOARD/INIT',
    FetchPublicDashboardTiles = 'FETCH_PUBLIC_DASHBOARD_TILES/INIT',
    FetchPublicDashboardSuccess = 'FETCH_PUBLIC_DASHBOARD_SUCCESS',
    FetchPublicDashboardTilesSuccess = 'FETCH_PUBLIC_DASHBOARD_TILES_SUCCESS',
}

export interface GetPublicDashboardTiles {
    requestActionType: RequestActionType.Init;
    requestType: PublicRequestType.FetchPublicDashboardTiles;
    type: PublicDashboardActionType.FetchPublicDashboardTiles;
    payload: { dashboardUrl: string; measurementSystem?: string };
}

export interface GetPublicDashboard {
    requestActionType: RequestActionType.Init;
    requestType: PublicRequestType.FetchPublicDashboard;
    type: PublicDashboardActionType.FetchPublicDashboard;
    payload: { dashboardUrl: string; measurementSystem?: string };
}

export type GetDashboardPayload = {
    dashboardUrl: string;
    measurementSystem?: string;
};

export const getPublicDashboardTiles = (payload: GetDashboardPayload): GetPublicDashboardTiles => ({
    requestActionType: RequestActionType.Init,
    requestType: PublicRequestType.FetchPublicDashboardTiles,
    type: PublicDashboardActionType.FetchPublicDashboardTiles,
    payload,
});

export const getPublicDashboard = (payload: GetDashboardPayload): GetPublicDashboard => ({
    requestActionType: RequestActionType.Init,
    requestType: PublicRequestType.FetchPublicDashboard,
    type: PublicDashboardActionType.FetchPublicDashboard,
    payload,
});

export interface GetPublicDashboardTilesSuccess {
    type: PublicDashboardActionType.FetchPublicDashboardTilesSuccess;
    payload: DashboardResponse;
}
export const getPublicDashboardTilesSuccess = (payload: DashboardResponse): GetPublicDashboardTilesSuccess => ({
    type: PublicDashboardActionType.FetchPublicDashboardTilesSuccess,
    payload,
});

export interface GetPublicDashboardSuccess {
    type: PublicDashboardActionType.FetchPublicDashboardSuccess;
    payload: { info: PublicDashboardProps };
}
export const getPublicDashboardSuccess = (payload: { info: PublicDashboardProps }): GetPublicDashboardSuccess => ({
    type: PublicDashboardActionType.FetchPublicDashboardSuccess,
    payload,
});

export type PublicDashboardActions = GetPublicDashboardSuccess | GetPublicDashboardTilesSuccess | EmptyAction;
